import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

// 👉 Photo data (you can replace URLs with your own S3 links)
const photoTestimonials = [
  {
    img: "./award 1.jpeg",
    caption: "Successful spine surgery recovery",
  },
  {
    img: "./award 3.jpeg",
    caption: "Happy patient after treatment",
  },
  {
    img: "./award_2-removebg-preview.png",
    caption: "Clinic environment & facilities",
  },
  {
    img: "./award 1.jpeg",
    caption: "Post-surgery follow-up session",
  },
  {
    img: "./award 3.jpeg",
    caption: "Patient sharing experience",
  },
  {
    img: "./award_2-removebg-preview.png",
    caption: "Team at Ortho Spine Care",
  },
];

const AboutLast = () => {
  return (
    <section className="about-last-section py-5">
      <div className="container text-center">
        <h2 className="fw-bold my-3">Awards and Recognition</h2>

        {/* ⭐ Photo Slider (auto, every 10s) */}
        <Swiper
          modules={[Navigation, Autoplay]}
          navigation
          autoplay={{
            delay: 10000, // 10 seconds
            disableOnInteraction: false,
          }}
          slidesPerView={3}
          centeredSlides={true}
          spaceBetween={2} // Changed from 30 to 15 for less gap
          loop={true}
          speed={600}
          breakpoints={{
            0: {
              slidesPerView: 1,
              spaceBetween: 10, // Reduced gap on mobile
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 12, // Reduced gap on tablet
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 5, // Reduced gap on desktop
            },
          }}
        >
          {photoTestimonials.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="photo-testimonial-wrapper">
                <div className="photo-card-small">
                  <img
                    src={item.img}
                    alt={item.caption || "About last"}
                    className="photo-element-small"
                  />
                  {item.caption && (
                    <div className="photo-caption-small">{item.caption}</div>
                  )}
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <style jsx>{`
        /* Photo wrapper - centers the card */
        .photo-testimonial-wrapper {
          display: flex;
          justify-content: center;
          align-items: center;
          padding-top:1rem;
        }

        /* Small photo card */
        .photo-card-small {
          background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
          border-radius: 10px;
          padding: 9px;
          width: 100%;
          max-width: 280px;
          box-shadow: 0 12px 25px rgba(0, 0, 0, 0.25);
          transition: all 0.3s ease;
          cursor: pointer;
        }

        /* Hover effect */
        .photo-card-small:hover {
          transform: translateY(-5px);
          box-shadow: 0 20px 35px rgba(0, 0, 0, 0.35);
        }

        /* Small image styling */
        .photo-element-small {
          width: 100%;
          height: 300px;
          border-radius: 10px;
          object-fit: cover;
          background-color: #000;
          display: block;
        }

        /* Caption styling */
        .photo-caption-small {
          font-size: 12px;
          font-weight: 500;
          color: #eaeaea;
          margin-top: 8px;
          text-align: center;
          letter-spacing: 0.3px;
        }

        /* Scale effect for non-active slides */
        .swiper-slide .photo-card-small {
          transform: scale(0.85);
          opacity: 0.7;
          transition: all 0.35s ease;
        }

        /* Active slide (center) */
        .swiper-slide-active .photo-card-small {
          transform: scale(1);
          opacity: 1;
        }

        /* Previous and next slides */
        .swiper-slide-prev .photo-card-small,
        .swiper-slide-next .photo-card-small {
          transform: scale(0.92);
          opacity: 0.85;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .photo-card-small {
            max-width: 240px;
            padding: 10px;
          }

          .photo-element-small {
            height: 170px;
          }

          .photo-caption-small {
            font-size: 11px;
          }
        }

        @media (max-width: 480px) {
          .photo-card-small {
            max-width: 220px;
            padding: 8px;
          }

          .photo-element-small {
            height: 150px;
          }

          .photo-caption-small {
            font-size: 10px;
          }
        }
      `}</style>
    </section>
  );
};

export default AboutLast;
